"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledSystem = require("styled-system");
var _default = (0, _styledSystem.style)({
  prop: 'outline'
});
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzdHlsZSIsInByb3AiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY3VzdG9tUHJvcHMvb3V0bGluZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBzdHlsZSB9IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuXG5leHBvcnQgZGVmYXVsdCBzdHlsZSh7IHByb3A6ICdvdXRsaW5lJyB9KTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFBc0MsZUFFdkIsSUFBQUEsbUJBQUssRUFBQztFQUFFQyxJQUFJLEVBQUU7QUFBVSxDQUFDLENBQUM7QUFBQSJ9